import { Box, Typography } from '@mui/material';
import { UNIT_SYSTEM } from '../../../../shared/config/hydraulics_constants';
import { DATAGRID_TABLE_CELL_WIDTH } from '../../../../utils/constants';

const strippingTableColumns = (renderValueCell, renderActions, strippingUnit, unit, renderTripPipeTypeCell, renderReportEveryCell, renderCell, renderDrillFluidCell, renderTargetsEditAction) => [
  {
    field: 'runNumber',
    headerName: 'Run',
    headerAlign: 'center',
    align: 'center',
    renderCell,
  },
  {
    field: 'from',
    headerName: `From MD (${strippingUnit?.from?.label})`,
    renderHeader: () => (
      <Box>
        <Typography sx={{ fontSize: '1.2rem' }}>
          From MD
        </Typography>
        <Typography sx={{ fontSize: '1.2rem' }}>
          ({strippingUnit?.from?.label})
        </Typography>
      </Box>
    ),
    headerAlign: 'center',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 50,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    align: 'center',
    renderEditCell: renderValueCell,
    editable: true,
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return unit !== UNIT_SYSTEM.US ? value : value.toFixed(strippingUnit?.from.decimals);
    },
  },
  {
    field: 'to',
    headerName: `To MD (${strippingUnit?.to?.label})`,
    renderHeader: () => (
      <Box>
        <Typography sx={{ fontSize: '1.2rem' }}>
          To MD
        </Typography>
        <Typography sx={{ fontSize: '1.2rem' }}>
          ({strippingUnit?.to?.label})
        </Typography>
      </Box>
    ),
    headerAlign: 'center',
    align: 'center',
    renderEditCell: renderValueCell,
    editable: true,
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return unit !== UNIT_SYSTEM.US ? value : value.toFixed(strippingUnit?.to.decimals);
    },
  },
  {
    field: 'speed',
    headerName: `Trip Speed (${strippingUnit?.speed?.label})`,
    renderHeader: () => (
      <Box>
        <Typography sx={{ fontSize: '1.2rem' }}>
          Trip Speed
        </Typography>
        <Typography sx={{ fontSize: '1.2rem' }}>
          ({strippingUnit?.speed?.label})
        </Typography>
      </Box>
    ),
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    headerAlign: 'center',
    align: 'center',
    renderEditCell: renderValueCell,
    editable: true,
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return unit !== UNIT_SYSTEM.US ? value : value.toFixed(strippingUnit?.speed.decimals);
    },
  },
  {
    field: 'tubular',
    headerName: 'Tubular',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderTripPipeTypeCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'report_interval',
    headerName: `Intervals (${strippingUnit?.report_interval?.label})`,
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderReportEveryCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return unit !== UNIT_SYSTEM.US ? value : value.toFixed(strippingUnit?.report_interval.decimals);
    },
  },
  {
    field: 'filling_fluid_id',
    headerName: 'Filling Fluid',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH + 120,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderDrillFluidCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'target_data',
    headerName: 'Target',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH + 50,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderCell: renderTargetsEditAction,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'actions',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 70,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH - 80,
    headerName: 'Actions',
    headerAlign: 'center',
    align: 'center',
    renderCell: renderActions,
  }
];
export { strippingTableColumns };
